// Constants
export const autorizar = () => {
    return {
        autorizar: {
            id: {
                namepath: ['alertas_autorizar'],
                type: "number",
                label: "id",
                placeholder: "",
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: true,
                    predeterminate: null,
                }
            },
            name_path: {
                type: "string",
                label: "",
                placeholder: "",
                namepath: ['alertas_autorizar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: null,
                    list: "datos_afiliado",
                    label: 'name'
                }
            },
            cambios: {
                type: "string",
                label: "",
                placeholder: "",
                namepath: ['alertas_autorizar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            eliminar: {
                type: "number",
                label: "Valor",
                placeholder: "",
                namepath: ['alertas_autorizar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "price",
                    disabled: false,
                    predeterminate: 0,
                }
            },
            tabla_delete: {
                type: "string",
                label: "",
                placeholder: "",
                namepath: ['alertas_autorizar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            nota: {
                type: "string",
                label: "",
                placeholder: "",
                namepath: ['alertas_autorizar'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
        }
    }
}